<template>
    <b-form-group
        :description="description"
        :label="label"
        :labelFor="fieldId"
        :class="groupClass"
        :state="!errors.has(name)"
        :invalid-feedback="errors.get(name)"
    >
        <template v-if="type === 'html'">
            <span v-html="html" v-bind="fieldBind()"></span>
        </template>

        <template v-if="type === 'hidden'">
            <input type="hidden" v-model="fieldValue" :name="name" v-bind="fieldBind()" />
        </template>

        <template v-if="type === 'text'">
            <b-form-input v-model="fieldValue" :name="name" type="text" :placeholder="placeholder" v-bind="fieldBind()"></b-form-input>
        </template>

        <template v-if="type === 'number'">
            <b-form-input v-model.number="fieldValue" type="number" :placeholder="placeholder" v-bind="fieldBind()"></b-form-input>
        </template>

        <template v-if="type === 'textarea'">
            <b-form-textarea v-model="fieldValue" :name="name" :placeholder="placeholder" v-bind="fieldBind()"></b-form-textarea>
        </template>

        <template v-if="type === 'switch' || type === 'boolean'">
            <toggle v-model="fieldValue" :name="name" v-bind="fieldBind()">{{ text }}</toggle>
        </template>

        <template v-if="type === 'radio'">
            <b-form-radio-group v-model="fieldValue" :name="name" v-bind="fieldBind()" :options="options"></b-form-radio-group>
        </template>

        <template v-if="type === 'checkbox'">
            <template v-if="options">
                <b-form-checkbox-group v-model="fieldValue" :name="name" v-bind="fieldBind()" :options="options"></b-form-checkbox-group>
            </template>
            <template v-else>
                <b-form-checkbox v-model="fieldValue" :name="name" value="accepted" v-bind="fieldBind()">{{ text }}</b-form-checkbox>
            </template>
        </template>

        <template v-if="type === 'select'">
            <b-form-select v-model="fieldValue" :name="name" v-bind="fieldBind()" :options="options">
                <template slot="first" v-if="first">
                    <option :value="null" disabled>{{ first }}</option>
                </template>
            </b-form-select>
        </template>

        <template v-if="type === 'date'">
            <datepicker v-model="fieldValue" :name="name" :placeholder="placeholder" v-bind="fieldBind()" :config="config"></datepicker>
        </template>

        <template v-if="type === 'time'">
            <timepicker v-model="fieldValue" :name="name" :placeholder="placeholder" v-bind="fieldBind()"></timepicker>
        </template>

        <template v-if="type === 'time'">
            <timepicker v-model="fieldValue" :name="name" :placeholder="placeholder" v-bind="fieldBind()"></timepicker>
        </template>

        <template v-if="type === 'multiselect'">
            <multiselect
                v-model="fieldValue"
                :options="options"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="placeholder"
                label="text"
                track-by="value"
                :preselect-first="true"
            ></multiselect>
        </template>

        <template v-if="type === 'modelselect'">
            <multiselect
                v-model="fieldValue"
                :options="options"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="placeholder"
                label="text"
                track-by="value"
                :preselect-first="true"
            ></multiselect>
        </template>

        <!--        <template v-if="field.type === 'datetime'">-->
        <!--        </template>-->

        <!--        <template v-if="field.type === 'image'">-->
        <!--        </template>-->

        <!--        <template v-if="field.type === 'file'">-->
        <!--        </template>-->

        <!--        <template v-if="field.type === 'range'">-->
        <!--        </template>-->

        <template v-if="type === 'submit'">
            <button
                type="submit"
                class="btn"
                :class="{
                    'btn-primary': !fieldClass,
                    [fieldClass]: fieldClass,
                }"
                v-bind="fieldBind()"
            >
                {{ text ? text : 'Submit' }}
            </button>
        </template>
    </b-form-group>
</template>

<script>
import _ from 'lodash';
import Toggle from '../../components/toggle/toggle';
import Datepicker from './Datepicker';
import Timepicker from './Timepicker';
import Multiselect from 'vue-multiselect';
import Errors from '../forms/Errors';

export default {
    components: { Timepicker, Toggle, Datepicker, Multiselect },
    props: {
        value: {
            required: false,
        },
        type: {
            type: String,
            required: true,
        },
        errors: {
            default() {
                return new Errors();
            },
        },
        html: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        options: {
            default: null,
        },

        label: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        first: {
            default: false,
        },
        placeholder: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        transform: {
            default: null,
        },
        id: {
            type: String,
            default: null,
        },
        groupClass: {
            type: String,
            default: null,
        },
        config: {
            default: null,
        },
        fieldClass: {
            type: String,
            default: null,
        },
        fieldAttributes: {
            default() {
                return {};
            },
        },
    },
    data: () => ({
        busy: false,
        fieldValue: null,
    }),
    computed: {
        fieldId() {
            return this.id ? this.id : `${this.name}Field`;
        },
    },
    methods: {
        _get: _.get,
        fieldBind(attr = {}) {
            return _.merge(
                {
                    id: this.fieldId,
                    dusk: `${this.name}Field`,
                },
                this.fieldAttributes,
                attr,
            );
        },
        transformer(newVal) {
            return newVal;
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal === oldVal) return;
                this.fieldValue = this.transformer(newVal);
            },
        },
        fieldValue: {
            deep: true,
            handler(newVal) {
                this.$emit('input', this.transformer(newVal));
            },
        },
    },
};
</script>
